import { Link, IconExternalLinkLine as IconExternalLink } from "@instructure/ui";
import React, { Component } from "react";
import NavLink from "./NavLink";
import { resourceTypes } from "./constants";
import { Trans } from "@lingui/react/macro";

export default class WebLinkListItem extends Component {
  render() {
    return (
      <li className="ExpandCollapseList-item">
        <div className="ExpandCollapseList-item-inner">
          <div>
            {this.props.item.type === resourceTypes.WEB_LINK && (
              <span className="resource-icon">
                <IconExternalLink />
              </span>
            )}
          </div>

          <div style={{ flex: 1 }}>
            {this.props.item.href && (
              <Link
                as={NavLink}
                to={{
                  pathname: this.props.isModuleItem
                    ? `module-items/${this.props.identifier}`
                    : `resources/${this.props.identifier}`,
                }}
              >
                <span>{this.props.item.title || <Trans>Untitled</Trans>}</span>
              </Link>
            )}
          </div>
        </div>
      </li>
    );
  }
}
